module.exports = __webpack_public_path__ + "img/Blue-bull.697596c6.svg";